module.exports = __webpack_public_path__ + "img/DropImg.349d13ea.png";